import {OrdersSliceState} from '../../orders-slice';
import {PayloadAction} from '@reduxjs/toolkit';

// 使用画像
export const setImage = (state: OrdersSliceState, action: PayloadAction<File[]>) => {
  state.useImage.image = action.payload;
};
